export default "__VITE_ASSET__D2$ay9hL__"